import { render } from "./SustainabilityCommitment.vue?vue&type=template&id=013b2c7a&scoped=true"
import script from "./SustainabilityCommitment.vue?vue&type=script&lang=js"
export * from "./SustainabilityCommitment.vue?vue&type=script&lang=js"

import "./SustainabilityCommitment.vue?vue&type=style&index=0&id=013b2c7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013b2c7a"]])

export default __exports__